import { colors } from '../colors'

export const MuiFormLabel = {
  root: {
    color: colors.text,
  },
}
